import styles from './Spinner.module.css';

const Spinner = () => {

    return (
        <div className={styles.container}>
            <div className={styles.spinner} />
        </div>
    )
}

export default Spinner;